/**
 * PATH: packages/ui/src/mobile/headerTitleSlot.ts
 * FILE_ID: UI-MOBILE-HEADER-TITLE-SLOT-001
 * PURPOSE: Phone-only slot beside the shell header's page title, so a page can
 *      put one control next to the title instead of spending a row on it.
 * LANDMINE: null when the host header has no slot (tenant shells) or the slot
 *      is detached. Callers keep their own in-page fallback for that case.
 *      Re-queried every commit so a remounted shell Header is picked up.
 */
import { useEffect, useLayoutEffect, useState } from 'react'

export const HEADER_MOBILE_TITLE_SLOT_ID = 'quotech-header-mobile-title-slot'

const useIsoLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect

export function useHeaderMobileTitleSlot(id = HEADER_MOBILE_TITLE_SLOT_ID): HTMLElement | null {
  const [slot, setSlot] = useState<HTMLElement | null>(null)
  useIsoLayoutEffect(() => {
    const next = document.getElementById(id)
    if (next !== slot) setSlot(next)
  }, [id, slot])
  return slot && slot.isConnected ? slot : null
}
